import { makeSubStore } from '@jarvis.oddle/core/tools/redux/store'
import { STORE_KEY } from './constants'
import * as actions from './actions'
import { initialState, reducers } from './reducers'

export const initialiseState = async ({ req, store }) => {
  const orderState = store.getState()[STORE_KEY]
  const { storeOrder } = orderState
  const initialiseActions = []

  if (!orderState.availableTimeSlots.fetched) {
    initialiseActions.push(store.dispatch(actions.fetchTimeSlotsAction({ req, date: storeOrder.fetched ? storeOrder.data.collectionDate : new Date() })))
  }

  await Promise.all(initialiseActions)
}

export default makeSubStore(STORE_KEY, actions, reducers, initialState, initialiseState)
